<template>
  <div style="height: 100%;width: 100%;">
    <el-tabs v-model="activeId">
      <el-tab-pane label="从左往右树状视图" name="1">
        <tree-chart :data="data" ref="treeDiagram" style="height: 70vh;"></tree-chart>
      </el-tab-pane>
      <el-tab-pane label="径向树状视图" name="2">
        <tree-chart :data="data" :extend-data="extendData" ref="treeDiagram" style="height: 70vh;"></tree-chart>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import TreeChart from "@/components/echarts/TreeChart";
import {getSpaceDeviceTree} from "@/network/device-info";

export default {
  name: "TreeDiagram",
  components: {TreeChart},
  data() {
    return {
      data: [],
      imgUrl: require('../../../assets/images/topology/主机.png'),
      activeId: '1',
      extendData: null,
    }
  },
  mounted() {
    this.getSpaceDeviceTree();
    this.extendData = {
      series: [{
        layout: 'radial',
      }]
    }
  },
  methods: {
    getSpaceDeviceTree() {
      getSpaceDeviceTree().then(res => {
        this.data = res.data.map(item => {
          if (item.parentId === '-1') {
            item.symbol = "image://" + this.imgUrl;
          }
          return item;
        })
        console.log(this.data);
      })
    }
  }
}
</script>

<style scoped>

</style>
